// extracted by mini-css-extract-plugin
module.exports = {"siabOverlay":"App_siabOverlay__2yc7t","siabClose":"App_siabClose__1XufQ","siabModal":"App_siabModal__3awt3","siabHeader":"App_siabHeader__2keeH"};